import RestModule from "../vue-ocom/store/RestModule";
import schema from "./schema/index";
import CreateUserModule from "../vue-ocom/store/CreateUserModule";
import {FileSystemModule} from "../vue-ocom/filesystem/store";
import CreateReport from "../vue-ocom/reports/ReportsModule";

var root_url = process.env.VUE_APP_ROOT_API;

const UserModule = CreateUserModule(root_url);

const CustomerModule = RestModule(root_url + "/api/customer/", schema.Customer);
const JobModule = RestModule(root_url + "/api/job/", schema.Job);
const OnSiteContactModule = RestModule(
  root_url + "/api/on_site_contact/",
  schema.OnSiteContact
);
const CodeTruckModule = RestModule(
  root_url + "/api/code_truck/",
  schema.CodeTruck
);
const CodeProductModule = RestModule(
  root_url + "/api/code_product/",
  schema.CodeProduct
);
const JobProductModule = RestModule(
  root_url + "/api/job_product/",
  schema.JobProduct
);
const JobFileModule = RestModule(root_url + "/api/job_file/", schema.JobFile);
const CodeFileTypeModule = RestModule(
  root_url + "/api/code_file_type/",
  schema.CodeFileType
);
const CodeAreaModule = RestModule(
  root_url + "/api/code_area/",
  schema.CodeArea
);
const JobNoteModule = RestModule(root_url + "/api/job_note/", schema.JobNote);
const JobTaskModule = RestModule(root_url + "/api/job_task/", schema.JobTask);
const TruckSizeModule = RestModule(
  root_url + "/api/truck_size/",
  schema.TruckSize
);
const CodeJobTaskTypeModule = RestModule(
  root_url + "/api/code_job_task_type/",
  schema.CodeJobTaskType
);
const CodeTimeOfDayModule = RestModule(
  root_url + "/api/code_time_of_day/",
  schema.CodeTimeOfDay
);
//Add more modules here if needed. These will automatically be included and available in main store.
const ReportsModule = CreateReport(root_url);
const JobTaskAllocationModule = RestModule(
  root_url + "/api/job_task_allocation/",
  schema.JobTask
);
const JobAllocationModule = RestModule(
  root_url + "/api/job_allocation/",
  schema.Job
);
const PreStartCheckListModule = RestModule(
  root_url + "/data/v1/pre_start_check_list/",
  schema.PreStartCheckList
);

export default {
  UserModule,

  CustomerModule,
  JobModule,
  OnSiteContactModule,
  CodeTruckModule,
  CodeProductModule,
  JobProductModule,
  JobFileModule,
  CodeFileTypeModule,
  CodeAreaModule,
  JobNoteModule,
  JobTaskModule,
  TruckSizeModule,
  CodeJobTaskTypeModule,
  //Add more modules here
  JobTaskAllocationModule,
  FileSystemModule,
  ReportsModule,
  CodeTimeOfDayModule,
  JobAllocationModule,
  PreStartCheckListModule,
};
